import React, { ReactNode } from "react";

import { Layout } from "../../base";
import { isDevelopment } from "../../modules/config";
import NetworkInfo from "../Debug/NetworkInfo";
import HeaderCenter from "./HeaderCenter";
import HeaderLeft from "./HeaderLeft";
import HeaderRight from "./HeaderRight";

// const Container = styled(Flex)`
//   flex-direction: column;
//   height: 100%;
//   min-height: 900px;
//   width: 100%;

//   background-image: linear-gradient(to bottom, #fff, #e9e9e9);

//   @media screen and (max-width: 560px) {
//     min-height: 667px;
//   }
// `

const Page = ({ children }: { children: ReactNode }) => (
  <Layout
    header={{
      content: (
        <>
          <HeaderLeft />
          <HeaderCenter />
          <HeaderRight />
        </>
      ),
    }}
  >
    {children}
    {isDevelopment() && (false as boolean) ? <NetworkInfo /> : null}
  </Layout>
);

export default Page;
